import type { NextPage } from 'next';
import { useRouter } from 'next/router';
import { Page as Component } from '~/components/specifics/settings/imports/[importType]/Page';
import { NskHead } from '~/components/common/head/NskHead';
import type { ImportType } from '~/models/ImportLog';

export const PATH = (importType: ImportType): string =>
  `/settings/imports/${importType}`;

const Home: NextPage = () => {
  const router = useRouter();
  const { importType } = router.query;

  if (typeof importType !== 'string') return null;

  return (
    <>
      <NskHead title="過去データ取込" />
      <Component importType={importType} />
    </>
  );
};

export default Home;
